class McmMobileDiscover extends HTMLElement {
 connectedCallback() {
  this.details=this.closest('details');
  this.toggle=()=>{if(this.details?.open)this.load();};
  this.details?.addEventListener('toggle',this.toggle);
  this.toggle();
 }
 load() {
  if(this.loaded)return;
  const source=[...document.querySelectorAll('.mcm-hnav-section [data-mcm-discover-group]')].find(group=>group.dataset.index===this.dataset.categoryIndex);
  if(!source)return;
  this.loaded=true;
  const group=source.cloneNode(true);group.hidden=false;
  const prefix='mcm-mobile-'+this.closest('details').id+'-';
  const ids=new Map();
  group.querySelectorAll('[id]').forEach(node=>{const old=node.id;node.id=prefix+old;ids.set(old,node.id);});
  group.querySelectorAll('*').forEach(node=>{
   for(const name of ['for','aria-controls','aria-labelledby','aria-describedby']){
    if(node.hasAttribute(name))node.setAttribute(name,node.getAttribute(name).split(/\s+/).map(value=>ids.get(value)||value).join(' '));
   }
   if(node.getAttribute('href')?.startsWith('#')){const id=node.getAttribute('href').slice(1);if(ids.has(id))node.setAttribute('href','#'+ids.get(id));}
  });
  group.querySelectorAll('[data-mcm-auto]').forEach(block=>{
   block.hidden=false;block.removeAttribute('aria-busy');
   block.querySelector('[data-mcm-auto-results]')?.replaceChildren();
  });
  const nav=document.createElement('div');nav.dataset.mcmHnav='';
  const panel=document.createElement('div');panel.dataset.mcmPanel='';
  const aside=document.createElement('div');aside.className='mcm-hnav__discover';aside.append(group);panel.append(aside);nav.append(panel);this.append(nav);
  this.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true}));
 }
 disconnectedCallback(){this.details?.removeEventListener('toggle',this.toggle);}
}
if(!customElements.get('mcm-mobile-discover'))customElements.define('mcm-mobile-discover',McmMobileDiscover);
